import { render, staticRenderFns } from "./newBKMV.vue?vue&type=template&id=502fb454&scoped=true"
import script from "./newBKMV.vue?vue&type=script&lang=js"
export * from "./newBKMV.vue?vue&type=script&lang=js"
import style0 from "./newBKMV.vue?vue&type=style&index=0&id=502fb454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fb454",
  null
  
)

export default component.exports